import { ua } from "./functions/ua.es6";
import ScrollFunc from "./classes/scrollfunc.es6";
import FooterFamily from "./classes/footerFamiliy.es6";
import Light from "./classes/light.es6";
import HeadFoot from "./classes/headfoot.es6";

export default class Main {
    constructor() {
        this.headFoot = new HeadFoot();
        this.scrollFunc = new ScrollFunc();
        this.footerFamiliy = new FooterFamily();
        this.light = new Light();
        this.init();
    }

    init() {
        ua();
        this.setLoaded();
    }

    setLoaded() {
        document.body.setAttribute("data-pageloaded", "1");

        const inter = document.querySelector(".news__single__inter");

        if (inter) {
            setTimeout(() => {
                inter.querySelector("svg").classList.add("active");
            }, 10);
        }
    }
}
